module.exports = __webpack_public_path__ + "img/Shop.f61c1f41.svg";